import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59627dd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "product-image" }
const _hoisted_3 = {
  key: 0,
  class: "product-info"
}
const _hoisted_4 = { class: "ion-padding" }
const _hoisted_5 = { class: "product-features" }
const _hoisted_6 = {
  key: 1,
  class: "product-info"
}
const _hoisted_7 = { class: "ion-padding" }
const _hoisted_8 = { class: "product-features" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/audit" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Product audit")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.product?.productId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (!Object.keys(_ctx.currentVariant).length)
                      ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                          key: 0,
                          animated: ""
                        }))
                      : (_openBlock(), _createBlock(_component_DxpShopifyImg, {
                          key: 1,
                          src: _ctx.currentVariant.mainImageUrl
                        }, null, 8, ["src"]))
                  ]),
                  (Object.keys(_ctx.currentVariant).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.currentVariant) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.currentVariant) : _ctx.currentVariant.productName), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.currentVariant)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleFeatures, ([feature, featureOptions]) => {
                            return (_openBlock(), _createBlock(_component_ion_list, { key: feature }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_list_header, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(feature), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_item, { lines: "none" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_row, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featureOptions, (option) => {
                                          return (_openBlock(), _createBlock(_component_ion_chip, {
                                            outline: _ctx.selectedFeatures[feature] !== option,
                                            key: option,
                                            onClick: ($event: any) => (_ctx.selectedFeatures[feature] !== option && _ctx.applyFeature(option, feature))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(option), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["outline", "onClick"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_ion_skeleton_text, {
                            animated: "",
                            style: {"width":"60%","height":"80%"}
                          }),
                          _createVNode(_component_ion_skeleton_text, {
                            animated: "",
                            style: {"width":"40%","height":"40%"}
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_ion_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                class: "ion-margin",
                                animated: "",
                                style: {"width":"30%"}
                              }),
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_skeleton_text, {
                                    animated: "",
                                    style: {"width":"60%"}
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                class: "ion-margin",
                                animated: "",
                                style: {"width":"30%"}
                              }),
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_skeleton_text, {
                                    animated: "",
                                    style: {"width":"60%"}
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])),
                  _createElementVNode("div", null, [
                    (!_ctx.poSummary.listingCountStatusMessage)
                      ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Eligible")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_skeleton_text, {
                                  slot: "end",
                                  animated: "",
                                  style: {"height":"30%","width":"20%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Category")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_skeleton_text, {
                                  slot: "end",
                                  animated: "",
                                  style: {"height":"30%","width":"40%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Shopify listing")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_skeleton_text, {
                                  slot: "end",
                                  animated: "",
                                  style: {"height":"30%","width":"50%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item_divider, { color: "light" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "medium" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Timeline")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.shirtOutline
                                }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, { lines: "none" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_skeleton_text, {
                                          animated: "",
                                          style: {"width":"90%","height":"30%"}
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, { lines: "none" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_skeleton_text, {
                                          animated: "",
                                          style: {"width":"100%","height":"60%"}
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ion_card, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Eligible")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.poSummary.eligible ? _ctx.$t("Yes") : _ctx.$t("No")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Category")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.poSummary.categoryId === _ctx.preOrderCategoryId ? _ctx.$t('Pre-order') : _ctx.poSummary.categoryId === _ctx.backorderCategoryId ? _ctx.$t('Back-order') : _ctx.$t('None')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_icon, {
                                  slot: "end",
                                  icon: _ctx.isCategoryValid() ? _ctx.checkmarkCircleOutline : _ctx.alertCircleOutline,
                                  color: _ctx.isCategoryValid() ? 'success' : 'warning'
                                }, null, 8, ["icon", "color"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Shopify listing")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.poSummary.listingCountStatusMessage), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_icon, {
                                  slot: "end",
                                  icon: _ctx.isShopifyListingValid() ? _ctx.checkmarkCircleOutline : _ctx.alertCircleOutline,
                                  color: _ctx.isShopifyListingValid() ? 'success' : 'warning'
                                }, null, 8, ["icon", "color"])
                              ]),
                              _: 1
                            }),
                            (_ctx.poSummary.promiseDate)
                              ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("Promise date")), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.poSummary.promiseDate), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_item_divider, { color: "light" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "medium" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Timeline")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.poSummary.header || _ctx.poSummary.body)
                              ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      icon: _ctx.shirtOutline
                                    }, null, 8, ["icon"]),
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        (_ctx.poSummary.header)
                                          ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _toDisplayString(_ctx.poSummary.header), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.poSummary.body)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.poSummary.body), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                  ])
                ]),
                _hoisted_11,
                _createElementVNode("section", null, [
                  (!Object.keys(_ctx.poAndAtpDetails).length)
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: "",
                                style: {"height":"40%","width":"70%"}
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: "",
                                style: {"height":"30%","width":"40%"}
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: "",
                                style: {"height":"30%","width":"50%"}
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: "",
                                style: {"height":"30%","width":"40%"}
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: "",
                                style: {"height":"30%","width":"50%"}
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: "",
                                style: {"height":"30%","width":"40%"}
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: "",
                                style: {"height":"30%","width":"50%"}
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (Object.keys(_ctx.poAndAtpDetails.activePo).length)
                      ? (_openBlock(), _createBlock(_component_ion_card, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_title, null, {
                                  default: _withCtx(() => [
                                    (_ctx.hasCategory())
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_12, _toDisplayString(_ctx.$t("Active purchase order")), 1))
                                      : (_openBlock(), _createElementBlock("h3", _hoisted_13, _toDisplayString(_ctx.$t("Available purchase order")), 1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.poAndAtpDetails.activePo.orderExternalId ? _ctx.poAndAtpDetails.activePo?.orderExternalId :  _ctx.poAndAtpDetails.activePoId), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.poAndAtpDetails.activePo?.estimatedDeliveryDate ? _ctx.getTime(_ctx.poAndAtpDetails.activePo.estimatedDeliveryDate) : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Pre-selling category')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.poAndAtpDetails.activePo?.isNewProduct === "Y" ? _ctx.$t('Pre-order') : _ctx.$t('Back-order')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Ordered")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.poAndAtpDetails.activePo?.quantity >= 0) ? _ctx.poAndAtpDetails.activePo?.quantity : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Available")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.poAndAtpDetails.activePo?.availableToPromise >= 0) ? _ctx.poAndAtpDetails.activePo?.availableToPromise : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Corresponding sales orders")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.poAndAtpDetails.crspndgSalesOrdr >= 0) ? _ctx.poAndAtpDetails.crspndgSalesOrdr : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Total PO items")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.poAndAtpDetails.totalPoItems >= 0) ? _ctx.poAndAtpDetails.totalPoItems : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Total PO ATP")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.poAndAtpDetails.totalPoAtp >= 0) ? _ctx.poAndAtpDetails.totalPoAtp : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ion_card, { key: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_header, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_title, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Purchase orders")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Total PO items")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.poAndAtpDetails.totalPoItems >= 0) ? _ctx.poAndAtpDetails.totalPoItems : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Total PO ATP")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.poAndAtpDetails.totalPoAtp >= 0) ? _ctx.poAndAtpDetails.totalPoAtp : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Online ATP calculation")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!Object.keys(_ctx.inventoryConfig).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"40%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"50%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"40%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"50%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"40%"}
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Online ATP")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.atpCalcDetails.onlineAtp >= 0) ? _ctx.atpCalcDetails.onlineAtp : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Quantity on hand")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.atpCalcDetails.totalQOH >= 0) ? _ctx.atpCalcDetails.totalQOH : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Excluded ATP")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString((_ctx.atpCalcDetails.excludedAtp || _ctx.atpCalcDetails.excludedAtp === 0) ? _ctx.atpCalcDetails.excludedAtp : '-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_toggle, {
                                  disabled: !_ctx.inventoryConfig.reserveInvStatus || !_ctx.hasPermission(_ctx.Actions.APP_INV_CNFG_UPDT),
                                  checked: _ctx.inventoryConfig.reserveInvStatus === 'Y',
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateReserveInvConfig($event)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Reserve inventory")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "checked"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_toggle, {
                                  disabled: !_ctx.inventoryConfig.preOrdPhyInvHoldStatus || !_ctx.hasPermission(_ctx.Actions.APP_INV_CNFG_UPDT),
                                  checked: _ctx.inventoryConfig.preOrdPhyInvHoldStatus != 'false',
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatePreOrdPhyInvHoldConfig($event)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("Hold pre-order physical inventory")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "checked"])
                              ]),
                              _: 1
                            })
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_16,
                _createElementVNode("section", null, [
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Related jobs')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.isCtgryAndBrkrngJobsLoaded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"40%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"50%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"40%"}
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            (Object.keys(_ctx.getCtgryAndBrkrngJob('JOB_REL_PREODR_CAT')).length)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 0,
                                  detail: "",
                                  button: "",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openJobActionsPopover($event, _ctx.getCtgryAndBrkrngJob('JOB_REL_PREODR_CAT'), 'Pre-sell computation')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Pre-sell computation')), 1),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.getCtgryAndBrkrngJob('JOB_REL_PREODR_CAT').lastRunTime && _ctx.timeTillJob(_ctx.getCtgryAndBrkrngJob('JOB_REL_PREODR_CAT').lastRunTime)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.getCtgryAndBrkrngJob('JOB_REL_PREODR_CAT').runTime ? _ctx.timeTillJob(_ctx.getCtgryAndBrkrngJob('JOB_REL_PREODR_CAT').runTime) : _ctx.$t('disabled')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (Object.keys(_ctx.getCtgryAndBrkrngJob('JOB_BKR_ORD')).length )
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 1,
                                  detail: "",
                                  button: "",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openJobActionsPopover($event, _ctx.getCtgryAndBrkrngJob('JOB_BKR_ORD'), 'Order brokering')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Order brokering')), 1),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.getCtgryAndBrkrngJob('JOB_BKR_ORD').lastRunTime && _ctx.timeTillJob(_ctx.getCtgryAndBrkrngJob('JOB_BKR_ORD').lastRunTime)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.getCtgryAndBrkrngJob('JOB_BKR_ORD').runTime ? _ctx.timeTillJob(_ctx.getCtgryAndBrkrngJob('JOB_BKR_ORD').runTime) : _ctx.$t('disabled')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (Object.keys(_ctx.getCtgryAndBrkrngJob('JOB_RLS_ORD_DTE')).length)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 2,
                                  detail: "",
                                  button: "",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openJobActionsPopover($event, _ctx.getCtgryAndBrkrngJob('JOB_RLS_ORD_DTE'), 'Auto releasing')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Auto releasing')), 1),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.getCtgryAndBrkrngJob('JOB_RLS_ORD_DTE').lastRunTime && _ctx.timeTillJob(_ctx.getCtgryAndBrkrngJob('JOB_RLS_ORD_DTE').lastRunTime)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_label, { slot: "end" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.getCtgryAndBrkrngJob('JOB_RLS_ORD_DTE').runTime ? _ctx.timeTillJob(_ctx.getCtgryAndBrkrngJob('JOB_RLS_ORD_DTE').runTime) : _ctx.$t('disabled')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Shop listing status')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.poSummary.listingCountStatusMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"40%","width":"60%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"40%"}
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: "",
                                  style: {"height":"30%","width":"50%"}
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (!Object.keys(_ctx.shopListings).length)
                              ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('No shop listings found')), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getSortedShopListings(_ctx.shopListings), (listData, index) => {
                                  return (_openBlock(), _createBlock(_component_ion_item, { key: index }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h5", null, _toDisplayString(listData.name), 1),
                                          _createElementVNode("p", null, _toDisplayString(listData.listingTimeAndStatus), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (listData.shopifyShopProductId && listData.status)
                                        ? (_openBlock(), _createBlock(_component_ion_label, {
                                            key: 0,
                                            color: listData.status === 'disconnected' ? 'medium' : (listData.containsError ? 'danger' : (listData.status === 'inactive' ? 'warning' : 'success')),
                                            slot: "end"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h5", null, _toDisplayString(_ctx.$t(listData.listingStatus)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["color"]))
                                        : (listData.shopifyShopProductId)
                                          ? (_openBlock(), _createBlock(_component_ion_label, {
                                              key: 1,
                                              color: "medium",
                                              slot: "end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("No listing data")), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_ion_label, {
                                              key: 2,
                                              color: "medium",
                                              slot: "end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("Not linked")), 1)
                                              ]),
                                              _: 1
                                            }))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                          ]))
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("No product found")), 1)
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}